import { NotificationRaw, NotificationWithReadState } from '../types';

export function mergeNotificationsWithReadState(
  notifications: NotificationRaw[],
  readMap: Map<string, boolean>
): NotificationWithReadState[] {
  return notifications.map((notif) => ({
    ...notif,
    id: notif['id'],
    read: readMap.get(notif['id']) || false,
  }));
}
